<template>
  <v-container v-if="!isMobile">
    <nav>
      <v-app-bar app height="80">
        <v-toolbar-title>
          <v-breadcrumbs :items="items" large></v-breadcrumbs>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <div class="mr-1">
          <v-select
            height="42"
            :items="location"
            item-value="_id"
            v-model="locationItem"
            @change="updateLocation"
            hide-details
            :item-text="
              (location) => {
                return location.location;
              }
            "
            prepend-inner-icon="mdi-map-marker"
            solo
            style="font-size: 15px;"
            outlined
            dense
          ></v-select>
        </div>
        <v-md-date-range-picker :presets="presets" opens="right" @change="updateData" class="mr-2">
          <v-card class="pa-2" slot="input" style="outline:1px solid grey;">
            <v-icon color="red darken-2"> mdi-clock-outline </v-icon> <span style="font-size: 15px;">{{ formatDate($store.state.dateTime1) }} - {{ formatDate($store.state.dateTime2) }}</span>
          </v-card>
        </v-md-date-range-picker>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn :loading="loading5" :disabled="loading5" :color="!timer ? 'red' : 'green'" :class="!timer ? 'ma-1 white--text' : 'ma-1 white--text'" @click="(timer = !timer), (loader = 'loading5')" fab small v-bind="attrs" v-on="on">
              <v-icon dark>
                {{ !timer ? "mdi-play" : "mdi-pause" }}
              </v-icon>
            </v-btn>
          </template>
          <span> {{ !timer ? "Enable Auto Refresh Page" : "Disable Auto Refresh Page" }}</span>
        </v-tooltip>
      </v-app-bar>
    </nav>

    <v-row>
      <v-col v-if="loading">
        <v-container style="height: 200px;">
          <v-row class="fill-height" align-content="center" justify="center">
            <v-col class="text-subtitle-1 text-center" cols="12">
              Getting your chart
            </v-col>
            <v-col cols="6">
              <v-progress-linear color="blue" indeterminate rounded height="6"></v-progress-linear>
            </v-col>
          </v-row>
        </v-container>
      </v-col>

      <v-col v-else>
        <v-col v-if="board.length == 0">
          <v-row class="fill-height" align-content="center" justify="center">
            <v-col class="text-subtitle-1 text-center" cols="12">
              No Data
            </v-col>
          </v-row>
        </v-col>
        <v-col v-else>
          <apexchart width="800" height="400" type="line" :options="currentChart" :series="currentSeries"></apexchart>
        </v-col>
      </v-col>

      <v-col>
        <v-row dense>
          <v-col>
            <p class="mx-auto text-center" style="font-size:12px;color:black;">Current</p>
            <v-card class="mx-auto text-center" color="white" dark max-width="200" max-height="100">
              <v-card-text>
                <div style="font-size:12px;color:black;">
                  Recently
                </div>
                <div style="font-size:18px;color:black;" v-if="board.length == 0">
                  No Data
                </div>
                <div style="font-size:18px;color:black;" v-else>{{ amp.slice(-1)[0].toFixed(2) }}<span style="font-size:10px;color:black;">A</span></div>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>

        <v-row dense>
          <v-col>
            <v-card class="mx-auto text-center" color="grey lighten-1" dark max-width="200" max-height="100">
              <div style="font-size:12px;color:black;">
                Peak
              </div>
              <div style="font-size:14.5px;color:black;" v-if="board.length == 0">
                No Data
              </div>
              <div style="font-size:14.5px;color:black;" v-else>{{ Math.max(...amp).toFixed(2) }}<span style="font-size:10px;color:black;">A</span></div>
            </v-card>
            <v-card class="mx-auto text-center" color="white" dark max-width="200" max-height="100">
              <div style="font-size:12px;color:black;">
                Min
              </div>
              <div style="font-size:14.5px;color:black;" v-if="board.length == 0">
                No Data
              </div>
              <div style="font-size:14.5px;color:black;" v-else>{{ Math.min(...amp).toFixed(2) }}<span style="font-size:10px;color:black;">A</span></div>
            </v-card>
          </v-col>
        </v-row>

        <v-row dense>
          <v-col>
            <v-card class="mx-auto text-center" color="white" dark max-width="200" max-height="100">
              <v-card-text>
                <div style="font-size:12px;color:black;">
                  Total Query Period
                </div>
                <div style="font-size:14.5px;color:black;" v-if="board.length == 0">
                  No Data
                </div>
                <div style="font-size:14.5px;color:black;" v-else>{{ amp.reduce((a, b) => a + b, 0).toFixed(2) }}<span style="font-size:10px;color:black;">A</span></div>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>

  <div v-else>
    <div class="mt-5 pa-1" justify="center" align="center">
      <div class="pa-1">
        <v-select
          :items="location"
          item-value="_id"
          v-model="locationItem"
          @change="updateLocation"
          hide-details
          :item-text="
            (location) => {
              return location.location;
            }
          "
          prepend-inner-icon="mdi-map-marker"
          solo
          style="font-size: 12px;"
        ></v-select>
      </div>

      <div class="pa-1">
        <v-card style="text-align:left; display:flex; justify-content:space-between;">
          <v-md-date-range-picker :presets="presets" opens="left" @change="updateData">
            <v-card class="pa-3" slot="input" flat>
              <v-icon color="red darken-2"> mdi-clock-outline </v-icon><span style="font-size: 12px; margin-left: 5px;">{{ formatDate($store.state.dateTime1) }} - </span> <span style="font-size: 12px;" v-if="values2 > Date.now()">Now</span><span style="font-size: 12px;" v-else> {{ formatDate($store.state.dateTime2) }}</span>
            </v-card>
          </v-md-date-range-picker>
        </v-card>
      </div>
    </div>

    <v-container>
      <div class="mt-5">
        <div v-if="loading">
          <v-container style="height: 200px;">
            <v-row class="fill-height" align-content="center" justify="center">
              <v-col class="text-subtitle-1 text-center" cols="12">
                <span style="font-size:12px">Getting your chart</span>
              </v-col>
              <v-col cols="6">
                <v-progress-linear color="blue" indeterminate rounded height="6"></v-progress-linear>
              </v-col>
            </v-row>
          </v-container>
        </div>

        <div v-else>
          <v-card class="pa-1 pt-5 pb-5">
            <apexchart height="200" type="line" :options="currentChart" :series="currentSeries"></apexchart>

            <div class="mt-5">
              <div style="display: flex; justify-content:center; margin-bottom: 10px;">
                <v-btn flat color="white" style="font-size: 10px; margin-right: 5px;" width="35vw">Recently</v-btn>
                <v-btn flat color="white" style="font-size: 10px; margin-right: 5px;" width="35vw" v-if="board.length == 0">No Data</v-btn>
                <v-btn flat color="white" style="font-size: 12px" width="35vw" v-else>{{ amp.slice(-1)[0].toFixed(2) }}<span style="font-size:12px;color:black;">A</span></v-btn>
              </div>
            </div>
            <div class="mt-5">
              <div style="display: flex; justify-content:center; margin-bottom: 10px;">
                <v-btn flat color="grey lighten-1" style="font-size: 10px; margin-right: 5px;" width="35vw">Peak</v-btn>
                <v-btn flat color="white" style="font-size: 10px; margin-right: 5px;" width="35vw" v-if="board.length == 0">No Data</v-btn>
                <v-btn flat color="white" style="font-size: 12px" width="35vw" v-else>{{ Math.max(...amp).toFixed(2) }}<span style="font-size:12px;color:black;">A</span></v-btn>
              </div>
            </div>
            <div class="mt-5">
              <div style="display: flex; justify-content:center; margin-bottom: 10px;">
                <v-btn flat color="white" style="font-size: 10px; margin-right: 5px;" width="35vw">Min</v-btn>
                <v-btn flat color="white" style="font-size: 10px; margin-right: 5px;" width="35vw" v-if="board.length == 0">No Data</v-btn>
                <v-btn flat color="white" style="font-size: 12px" width="35vw" v-else>{{ Math.min(...amp).toFixed(2) }}<span style="font-size:12px;color:black;">A</span></v-btn>
              </div>
            </div>
            <div class="mt-5">
              <div style="display: flex; justify-content:center; margin-bottom: 10px;">
                <v-btn flat color="white" style="font-size: 10px; margin-right: 5px;" width="35vw">Total Query Period</v-btn>
                <v-btn flat color="white" style="font-size: 10px; margin-right: 5px;" width="35vw" v-if="board.length == 0">No Data</v-btn>
                <v-btn flat color="white" style="font-size: 12px" width="35vw" v-else>{{ amp.reduce((a, b) => a + b, 0).toFixed(2) }}<span style="font-size:12px;color:black;">A</span></v-btn>
              </div>
            </div>
          </v-card>
        </div>
      </div>
    </v-container>
  </div>
</template>

<script>
  import Vue from "vue";
  import axios from "axios";
  import moment from "moment";
  import VueApexCharts from "vue-apexcharts";

  Vue.component("apexchart", VueApexCharts);

  export default {
    data: () => ({
      items: [
        {
          text: "Dashboard",
          disabled: false,
          href: "/",
        },
        {
          text: "Energy",
          disabled: true,
          href: "",
        },
        {
          text: "Usage By Location",
          disabled: true,
          href: "",
        },
      ],
      // values1: moment().subtract(24, "hour"),
      // values2: moment(),
      presets: [
        {
          label: "Last 1 Hour",
          range: [moment().subtract(1, "hour"), moment()],
        },
        {
          label: "Last 3 Hour",
          range: [moment().subtract(3, "hour"), moment()],
        },
        {
          label: "Last 12 Hour",
          range: [moment().subtract(12, "hour"), moment()],
        },
        {
          label: "Today",
          range: [moment().startOf("day"), moment().endOf("day")],
        },
        {
          label: "This Week",
          range: [
            moment()
              .clone()
              .startOf("week"),
            moment()
              .clone()
              .endOf("week"),
          ],
        },
        {
          label: "Last Week",
          range: [
            moment()
              .subtract(1, "weeks")
              .startOf("week"),
            moment()
              .subtract(1, "weeks")
              .endOf("week"),
          ],
        },
        {
          label: "This Month",
          range: [moment().startOf("month"), moment().endOf("month")],
        },
        {
          label: "Last Month",
          range: [moment().subtract(2, "month"), moment().subtract(1, "month")],
        },
      ],
      isMobile: true,
      loading: true,
      loading5: false,
      timer: true,
      loader: null,
      board: [],
      amp: [],
      location: [],
      locationItem: [],
      currentChart: {
        chart: {
          width: "100%",
          type: "line",
          animations: {
            enabled: false,
          },
        },
        markers: {
          size: 0,
        },
        dataLabels: {
          enabled: false,
        },
        xaxis: {
          tooltip: {
            enabled: false,
          },
          type: "datetime",
          labels: {
            datetimeUTC: false,
          },
        },
        tooltip: {
          x: {
            format: "dd MMM yyyy hh:mm:ss tt",
          },
        },
        legend: {
          show: false,
          showForSingleSeries: true,
          position: "top",
        },
        yaxis: {
          axisTicks: {
            show: true,
          },
          labels: {
            formatter: (val) => {
              return val.toFixed(2) + "A";
            },
          },
        },
        stroke: {
          show: true,
          curve: "smooth",
          lineCap: "butt",
          colors: undefined,
          width: 2,
          dashArray: 0,
        },
      },
      currentSeries: [
        {
          data: [],
        },
      ],
    }),
    mounted() {
      this.loadsBoard();
      this.loadsLocation();
      this.onResize();
      window.addEventListener("resize", this.onResize, { passive: true });
    },
    methods: {
      intervalFetchData: function() {
        setInterval(() => {
          if (this.timer == true) {
            this.loadsCo2(), this.loadsWeather();
          }
        }, 300000);
      },
      onResize() {
        this.isMobile = window.innerWidth < 700;
      },
      formatDate(value) {
        return moment(value).format("D MMM YYYY, h:mm:ss a");
      },
      loadsLocation: async function() {
        let apiURL = process.env.VUE_APP_API + "/api/location";
        axios
          .get(apiURL)
          .then((res) => {
            this.location = res.data;
            this.locationItem = this.location[0]._id;
            this.loadsBoard();
          })
          .catch((error) => {
            console.log(error);
          });
      },
      loadsBoard: async function() {
        let apiURL = process.env.VUE_APP_API + "/api/ecms/" + "location/" + this.locationItem + "/" + this.$store.state.dateTime1.toDate() + "/" + this.$store.state.dateTime2.toDate();
        axios
          .get(apiURL)
          .then((res) => {
            this.board = res.data;
            this.amp = res.data.map((amp) => amp.amp);

            let current = this.board.map((e) => {
              return {
                x: e.timestamp,
                y: e.amp,
              };
            });

            this.currentSeries = [
              {
                name: "Current",
                data: current,
              },
            ];
          })
          .catch((error) => {
            console.log(error);
          })
          .finally(() => (this.loading = false));
      },
      updateData(values) {
        this.values1 = values[0];
        this.values2 = values[1];
        this.$store.commit("setDateTime1", this.values1);
        this.$store.commit("setDateTime2", this.values2);
        this.loadsBoard();
        this.loading = true;
      },
      updateLocation() {
        this.loadsBoard();
        this.loading = true;
      },
    },
    beforeDestroy() {
      if (typeof window !== "undefined") {
        window.removeEventListener("resize", this.onResize, { passive: true });
      }
    },
    watch: {
      loader() {
        const l = this.loader;
        this[l] = !this[l];

        setTimeout(() => (this[l] = false), 500);

        this.loader = null;
      },
    },
  };
</script>

<style>
  .apexcharts-canvas {
    position: relative;
    user-select: none;
    z-index: 0;
  }
</style>
